import { Box, Button, Card, CardContent, Checkbox, Fade, Grid, Typography } from "@material-ui/core";
import { PessoaEnderecoModel } from "api/cardapio/models/pessoa/pessoa-model";
import React, { useMemo, useRef, useState } from "react"
import { useStyles } from "./formulario-endereco-styles";
import { FasesHeader } from "../../../components/fases-header/fases-header";
import { DadosDelivery, EnumOpcoesDelivery } from "storage";
import { useThemeQueries } from "theme/util-styles";
import { enderecoFormatado } from "utils/endereco-formatado";
import { useEmpresaAtual } from "services/hooks/empresa";
import { DeliveryDadosClienteForm, DeliveryDadosEntregaForm, DeliveryDadosInstancia } from "components/modals/dados-delivery/componentes";
import { useCardapioDadosStore } from "services/store/cardapio-dados-store";
import { usePedidos } from "services/providers/pedidos-provider";
import { useNotificacoes } from "components";
import { useDadosDeliveryStore } from "services/store/dados-delivery";
import { ConfirmarIcon } from "components/icons/confirmar-icon";
import { usePutEndereco } from "api/cardapio/queries/pessoa/put-endereco";
import { usePostNovoEndereco } from "api/cardapio/queries/pessoa/post-novo-endereco";
import { CircularLoading } from "components/utils/circular-loading";
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario";
import { picker } from "utils/picker";
import { guidEmpty } from "utils/guid-empty";
import { usePessoaUsuario } from "services/hooks/pessoa-usuario";

export type TFormularioEnderecoProps = {
    proximaEtapa: () => void
    voltar: () => void
    endereco: PessoaEnderecoModel
}

export const FormularioEndereco = ({ proximaEtapa, voltar, endereco }: TFormularioEnderecoProps) => {
    const classes = useStyles();
    const { theme, isMobile } = useThemeQueries()
    const { getEmpresaAtual } = useEmpresaAtual()
    const { cardapioDados } = useCardapioDadosStore()
    const empresa = getEmpresaAtual()
    const tipoDelivery = useDadosDeliveryStore(state => state.tipoDelivery)
    const [selectOpcaoDelivery, setSelectOpcaoDelivery] = useState<EnumOpcoesDelivery>(() => tipoDelivery ?? EnumOpcoesDelivery.Entrega)
    const { addOuAttProdutoEntrega, carregando: carregandoAddOuAttProdutoEntrega, removerItemEntregaSacola } = usePedidos()
    const {
        setTipoDelivery,
        setDadosWhatsapp,
        setEnderecoDelivery
    } = useDadosDeliveryStore()
    const [foraArea, setForaArea] = useState<boolean>(false)
    const { showErrorMessage } = useNotificacoes()
    const { permiteRetirada, permiteEntrega } = cardapioDados?.configuracoes || {}
    const deliveryHabilitado = cardapioDados?.configuracoesDelivery?.deliveryHabilitado ?? false
    const { putEndereco, carregando: carregandoPutEndereco } = usePutEndereco()
    const { postNovoEndereco, carregando: carregandoPostNovoEndereco } = usePostNovoEndereco()
    const { pessoa } = usePessoaUsuarioStore()
    const { carregarPessoa, carregando: carregandoCarregarPessoa } = usePessoaUsuario()

    const carregando = carregandoPutEndereco || carregandoPostNovoEndereco || carregandoAddOuAttProdutoEntrega || carregandoCarregarPessoa

    const refRetirada = useRef<DeliveryDadosInstancia>(null);
    const refEntrega = useRef<DeliveryDadosInstancia>(null);

    const handleNovoEndereco = async (novosDadosEndereco: PessoaEnderecoModel) => {
        const res = await postNovoEndereco({ ...novosDadosEndereco }, empresa?.id || '')
        if (res?.erro) throw res.erro

        return res.resultado?.data as PessoaEnderecoModel
    }

    const handleAtualizarEndereco = async (novosDadosEndereco: PessoaEnderecoModel) => {
        const res = await putEndereco({ ...novosDadosEndereco }, empresa?.id || '')
        if (res?.erro) throw res.erro

        return res.resultado?.data as PessoaEnderecoModel
    }

    const confirmarForms = async () => {
        try {
            setForaArea(false)
            let dadosEntrega;
            const dadosCliente = refRetirada.current?.submit();
            if (selectOpcaoDelivery === EnumOpcoesDelivery.Entrega) {
                dadosEntrega = refEntrega.current?.submit();
            }
            if (!deliveryHabilitado && (dadosEntrega?.sucesso === false || dadosCliente?.sucesso === false)) {
                return;
            }
            if (selectOpcaoDelivery === EnumOpcoesDelivery.Entrega || pessoa) {
                if (!dadosEntrega?.sucesso) {
                    return;
                }

                if (deliveryHabilitado && !pessoa) {
                    const res = await addOuAttProdutoEntrega({ ...dadosEntrega?.data })

                    if (res === false) {
                        setForaArea(true)
                        return;
                    }
                }

                const novosDadosEndereco = {
                    bairro: dadosEntrega?.data?.bairro,
                    cep: dadosEntrega?.data?.cep,
                    complemento: dadosEntrega?.data?.cpl,
                    xMun: dadosEntrega?.data?.municipio,
                    numero: dadosEntrega?.data?.nro,
                    logradouro: dadosEntrega?.data?.lgr,
                    referencia: dadosEntrega?.data?.referencia,
                    uf: dadosEntrega?.data?.uf,
                }

                const enderecoCompleto = picker<PessoaEnderecoModel>(novosDadosEndereco, endereco)
                if (pessoa) {
                    if (!enderecoCompleto.id || enderecoCompleto.id === guidEmpty()) {
                        enderecoCompleto.pessoaId = pessoa?.id || ''
                        const enderecoNovo = await handleNovoEndereco(enderecoCompleto)
                        setEnderecoDelivery(enderecoNovo);
                    } else {
                        await handleAtualizarEndereco(enderecoCompleto)
                        setEnderecoDelivery(enderecoCompleto);
                    }
                    await carregarPessoa()
                } else {
                    setEnderecoDelivery(enderecoCompleto);
                }

                setTipoDelivery(selectOpcaoDelivery);
                if (!deliveryHabilitado) {
                    if (dadosCliente?.sucesso) {
                        setDadosWhatsapp({
                            telefone: dadosCliente?.data?.telefone,
                            documento: dadosCliente?.data?.documento,
                            nome: dadosCliente?.data?.nome,
                        })
                    }
                }
            }

            if (selectOpcaoDelivery === EnumOpcoesDelivery.Retirada) {
                if (dadosCliente?.sucesso) {
                    setDadosWhatsapp({
                        telefone: dadosCliente?.data?.telefone,
                        documento: dadosCliente?.data?.documento,
                        nome: dadosCliente?.data?.nome,
                    })
                }
                removerItemEntregaSacola()
                setEnderecoDelivery(undefined)
                setTipoDelivery(selectOpcaoDelivery);
            }
            proximaEtapa()
        } catch (error: any) {
            showErrorMessage(error.message)
        }
    };

    const dadosDelivery: DadosDelivery = useMemo(() => {
        const { dadosWhatsapp, tipoDelivery } = useDadosDeliveryStore.getState()
        return {
            bairro: endereco?.bairro || '',
            cep: endereco?.cep || '',
            cpl: endereco?.complemento || '',
            municipio: endereco?.xMun || '',
            nro: endereco?.numero || '',
            lgr: endereco?.logradouro || '',
            referencia: endereco?.referencia || '',
            uf: endereco?.uf || '',
            documento: dadosWhatsapp?.documento || '',
            nome: dadosWhatsapp?.nome || '',
            telefone: dadosWhatsapp?.telefone || '',
            tipo: tipoDelivery ?? EnumOpcoesDelivery.Entrega,
        }
    }, [endereco?.bairro, endereco?.cep, endereco?.complemento, endereco?.logradouro, endereco?.numero, endereco?.referencia, endereco?.uf, endereco?.xMun])

    const conteudoFormEntrega = () => (
        <>
            {foraArea && (
                <Box ml={isMobile ? '11px' : 'unset'} bgcolor={theme.palette.error.main} mb={2} borderRadius={8} py={1} px={2} width="100%">
                    <Typography>
                        <Box fontWeight={400} color={theme.palette.common.white}>
                            Infelizmente sua localização está fora da área de entrega.
                        </Box>
                    </Typography>
                </Box>
            )}
            <Box display={selectOpcaoDelivery === EnumOpcoesDelivery.Entrega || pessoa ? 'flex' : 'none'}>
                <DeliveryDadosEntregaForm
                    ref={refEntrega}
                    dadosDelivery={dadosDelivery}
                    onSubmit={confirmarForms}
                />
            </Box>
        </>
    )

    return (
        <Fade in>
            <Box height={"100%"} width={"100%"} flex="1" display="flex" flexDirection="column">
                {carregando && <CircularLoading tipo="FULLSIZED" />}
                <FasesHeader titulo="Informar Endereço" voltar={voltar} />
                <Box flex="1" display="flex" flexDirection="column" component="form" onSubmit={(e) => {
                    e.preventDefault()
                    confirmarForms()
                }}>
                    <Box flex={1} p={2} height="0" overflow="auto">
                        <Grid container spacing={2}>
                            {!deliveryHabilitado && (
                                <DeliveryDadosClienteForm ref={refRetirada} dadosDelivery={dadosDelivery} modo={selectOpcaoDelivery ?? EnumOpcoesDelivery.Retirada} />
                            )}
                            {permiteRetirada && !pessoa && (
                                <Grid item style={{ width: '100%' }}>
                                    <Card
                                        variant="outlined"
                                        style={{
                                            display: 'flex',
                                            border:
                                                selectOpcaoDelivery === EnumOpcoesDelivery.Retirada
                                                    ? `2px solid ${theme.palette.primary.main}`
                                                    : '1px solid rgba(0, 0, 0, 0.12)',
                                        }}
                                        onClick={() => setSelectOpcaoDelivery(EnumOpcoesDelivery.Retirada)}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                color="primary"
                                                checked={selectOpcaoDelivery === EnumOpcoesDelivery.Retirada}
                                                style={{ marginLeft: !isMobile ? '5px' : 'unset' }}
                                            />
                                        </div>
                                        <div>
                                            <CardContent classes={{ root: classes.cardContentRoot }}>
                                                <Typography variant="h5">Retirar no Local</Typography>
                                                <Typography variant="body1">
                                                    {enderecoFormatado(
                                                        empresa?.logradouro || '',
                                                        empresa?.numero || '',
                                                        empresa?.bairro || '',
                                                        empresa?.municipio || '',
                                                        empresa?.uf || '',
                                                    )}
                                                </Typography>
                                            </CardContent>
                                        </div>
                                    </Card>
                                </Grid>
                            )}

                            {permiteEntrega && (
                                <Grid item style={{ width: '100%' }}>
                                    {pessoa ? conteudoFormEntrega() : (
                                        <Card
                                            variant="outlined"
                                            style={{
                                                display: 'flex',
                                                border:
                                                    selectOpcaoDelivery === EnumOpcoesDelivery.Entrega
                                                        ? `2px solid ${theme.palette.primary.main}`
                                                        : '1px solid rgba(0, 0, 0, 0.12)',
                                                minHeight: 60,
                                                alignItems: 'center',
                                            }}
                                            onClick={() => setSelectOpcaoDelivery(EnumOpcoesDelivery.Entrega)}
                                        >
                                            <CardContent classes={{ root: classes.cardContentRoot }}>
                                                <Typography variant="h5" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Checkbox checked={selectOpcaoDelivery === EnumOpcoesDelivery.Entrega} color="primary" />
                                                    Entregar no Meu Endereço
                                                </Typography>
                                                {conteudoFormEntrega()}
                                            </CardContent>
                                        </Card>
                                    )}
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                    <Box flex="0 0 auto" p={2}>
                        <Button variant="contained" size="large" type="submit" color="primary" fullWidth>
                            <ConfirmarIcon tipo="BUTTON_PRIMARY" />
                            Confirmar
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Fade>
    )
}